core.directive('edmDataGrid', ['$parse',
    function($parse) {
        var definition = {
            restrict: 'E',
            scope: {
                caption: '@',
                columnsInline: '@',
                columns: '=?',
                data: '=',
                numberOfPages: '=',
                criteria: '=?',
                showPaging: '@',
                onCriteriaChanged: '&'
            },
            templateUrl: 'core/application/directive/edmDataGrid/template/edm-data-grid.html',
            link: function($scope, element, attr) {
                if($scope.columnsInline) {
                    $scope.columns = $scope.$eval($scope.columnsInline);
                }

                if($scope.showPaging) {
                    $scope.showPaging = $scope.$eval($scope.showPaging);
                    $scope.$watch('numberOfPages', function (newVal) {
                        $scope.pagesArray = new Array(newVal);
                    });
                }

                var width = element.parent().width() - 30;
                var sum = 0;
                var columnsWithoutWidth = 0;

                $scope.columns.forEach(function (column) {
                    if(!_.isUndefined(column.width)) {
                        if(!isNaN(parseFloat(column.width)) && isFinite(column.width)) {
                            sum += column.width;
                            column.width = column.width + 'px';
                        }
                    } else {
                        columnsWithoutWidth++;
                    }
                });

                var widthToFill = width - sum;

                $scope.columns.forEach(function (column) {
                    if(_.isUndefined(column.width)) {
                        column.width = (widthToFill / columnsWithoutWidth) + 'px';
                    }
                });

                $scope.getValue = function (row, column) {
                    var value = null;
                    var getter = $parse(column.field);
                    return getter(row);
                };

                $scope.rowAction = function(a,b) {
                    $scope.$parent[a](b);
                };

                $scope.goToPage = function (index) {
                    $scope.criteria.pageNumber = index;
                    $scope.onCriteriaChanged();
                };
            }
        };

        return definition;
    }
]);